import { ListingSellerModel } from '@steelbuy/ts-shared';

import { createCollectionDataContext } from '../../util/provider/CollectionDataProvider';

export const ListingSellerCollectionData = createCollectionDataContext<ListingSellerModel>();
